import React, { useState } from 'react';
import { Mail, Phone, MapPin, Send } from 'lucide-react';

const eventTypes = [
  'Wedding',
  'Corporate Event',
  'Birthday Party',
  'Anniversary',
  'Conference',
  'Social Gathering',
  'Other'
];

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '', email: '', phone: '', eventType: '', date: '', guests: '', message: ''
  });
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };
  const handleSubmit = e => {
    e.preventDefault();
    setSnackbar({ open: true, message: 'Thank you for your message! We will contact you shortly.', severity: 'success' });
    setFormData({ name: '', email: '', phone: '', eventType: '', date: '', guests: '', message: '' });
  };

  return (
    <div className="w-full px-2 sm:px-4 md:px-12 xl:px-32 py-8">
      <section className="mb-12 text-center">
        <h1 className="text-3xl md:text-5xl font-bold mb-4 text-primary">Contact Us</h1>
        <p className="text-lg md:text-xl mb-8">Ready to start planning your next event? Get in touch with our team to discuss your vision.</p>
      </section>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
        {/* Contact Info */}
        <div>
          <h2 className="text-2xl font-bold mb-4 text-primary">Get In Touch</h2>
          <p className="mb-6">Have questions or ready to start planning your event? Our team is here to help you create unforgettable memories.</p>
          <div className="space-y-4">
            <div className="flex items-center gap-4 bg-white rounded-xl shadow p-4">
              <Mail className="w-6 h-6 text-primary" />
              <div>
                <div className="font-semibold">Email Us</div>
                <div className="text-gray-600">info@inderevents.com</div>
              </div>
            </div>
            <div className="flex items-center gap-4 bg-white rounded-xl shadow p-4">
              <Phone className="w-6 h-6 text-primary" />
              <div>
                <div className="font-semibold">Call Us</div>
                <div className="text-gray-600">(123) 456-7890</div>
              </div>
            </div>
            <div className="flex items-center gap-4 bg-white rounded-xl shadow p-4">
              <MapPin className="w-6 h-6 text-primary" />
              <div>
                <div className="font-semibold">Visit Our Office</div>
                <div className="text-gray-600">123 Event Avenue, Suite 100<br />Los Angeles, CA 90001</div>
              </div>
            </div>
          </div>
          <div className="mt-8">
            <h3 className="font-semibold mb-2">Office Hours</h3>
            <div className="text-gray-600 text-sm">
              Monday - Friday: 9:00 AM - 6:00 PM<br />
              Saturday: 10:00 AM - 4:00 PM<br />
              Sunday: Closed
            </div>
          </div>
        </div>
        {/* Contact Form */}
        <form className="bg-white rounded-xl shadow p-8 space-y-4" onSubmit={handleSubmit}>
          <h2 className="text-2xl font-bold mb-2 text-primary">Event Inquiry</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <input className="input" required name="name" value={formData.name} onChange={handleChange} placeholder="Your Name*" />
            <input className="input" required name="email" type="email" value={formData.email} onChange={handleChange} placeholder="Email Address*" />
            <input className="input" name="phone" value={formData.phone} onChange={handleChange} placeholder="Phone Number" />
            <select className="input" name="eventType" value={formData.eventType} onChange={handleChange}>
              <option value="">Event Type</option>
              {eventTypes.map(option => <option key={option} value={option}>{option}</option>)}
            </select>
            <input className="input" name="date" type="date" value={formData.date} onChange={handleChange} />
            <input className="input" name="guests" type="number" min="1" value={formData.guests} onChange={handleChange} placeholder="Number of Guests" />
          </div>
          <textarea className="input" name="message" rows={4} value={formData.message} onChange={handleChange} placeholder="Tell us about your event and any specific requirements..." />
          <button type="submit" className="bg-primary text-white px-6 py-3 rounded font-semibold flex items-center gap-2 hover:bg-primary/90 transition">
            Submit Inquiry <Send className="w-4 h-4" />
          </button>
          {snackbar.open && (
            <div className="mt-4 p-3 bg-green-100 text-green-800 rounded">{snackbar.message}</div>
          )}
        </form>
      </div>
      {/* Map Section */}
      <div className="mt-12">
        <h2 className="text-2xl font-bold mb-4 text-primary">Our Location</h2>
        <div className="rounded-xl overflow-hidden shadow">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d423286.27405770525!2d-118.69192047471653!3d34.02016130653034!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80c2c75ddc27da13%3A0xe22fdf6f254608f4!2sLos%20Angeles%2C%20CA%2C%20USA!5e0!3m2!1sen!2s!4v1656522284149!5m2!1sen!2s"
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Inder Events Location"
          ></iframe>
        </div>
      </div>
    </div>
  );
}
